import * as sites from 'app/mocks/data/park/sites/list'

import { TypeMachine } from 'app/types/shared/machine'

export const lockerDry1 = {
    id: 401,
    name: 'Locker dry 1 Mock',
    site: sites.site1,
    category: TypeMachine.enum.LOCKER_DRY,
    description: 'abc',
    stock_usage_percentage: 3,
    number_of_products: 9,
    max_products: 300,
    provider: 'E-thik',
    software_version: '1.14',
    build_date: '2022-08-29',
    installation_date: '2022-08-29',
    distributor_volume: 300,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '455',
    mode: 'Vente',
    enabled: true,
    online: false,
    is_low_stock: true,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 90,
    time_high_stock_check: '00:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    has_coin_acceptor: false,
    has_banknote_reader: false,
    user: 92,
    components: [],
}

export const lockerDry2 = {
    id: 402,
    name: 'Locker dry 2 Mock',
    site: sites.site11,
    category: TypeMachine.enum.LOCKER_DRY,
    description: 'abc',
    stock_usage_percentage: 3,
    number_of_products: 9,
    max_products: 300,
    provider: 'E-thik',
    software_version: '1.14',
    build_date: '2022-08-29',
    installation_date: '2022-08-29',
    distributor_volume: 300,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '455',
    mode: 'Vente',
    enabled: true,
    online: false,
    is_low_stock: true,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 90,
    time_high_stock_check: '00:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    has_coin_acceptor: false,
    has_banknote_reader: false,
    user: 92,
    components: [],
}

export const lockerDry3 = {
    id: 403,
    name: 'Locker dry 3 Mock',
    site: sites.site16,
    category: TypeMachine.enum.LOCKER_DRY,
    description: 'abc',
    stock_usage_percentage: 3,
    number_of_products: 9,
    max_products: 300,
    provider: 'E-thik',
    software_version: '1.14',
    build_date: '2022-08-29',
    installation_date: '2022-08-29',
    distributor_volume: 300,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '455',
    mode: 'Vente',
    enabled: true,
    online: false,
    is_low_stock: true,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 90,
    time_high_stock_check: '00:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    paygreen_shop_id: null,
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    has_coin_acceptor: false,
    has_banknote_reader: false,
    user: 92,
    components: [],
}
